var Interface = require('../core');
var _ = require('lodash');

var findDTD = function findDTD(req, sync) {
  var dtdType = undefined;
  var dtd = _.reduce(
    req.typeDef.dtdProperty.split('.'),
    function (o, propertyName) {
      return o[propertyName];
    },
    sync
  );

  if (!!req.typeDef.dtdType) {
    dtdType = req.typeDef.dtdType;
  }

  if (!!req.typeDef.dtdDynamicType) {
    dtdType = _.reduce(
      req.typeDef.dtdDynamicType.split('.'),
      function (o, propertyName) {
        return o[propertyName];
      },
      sync
    );
  }

  if (!!dtdType) {
    dtd = {
      __singleDataValue__: {
        type: dtdType,
        typeDef: dtd
      }
    };
  }

  return dtd;
};

var automaticRemoveSingleValue = function automaticRemoveSingleValue(req) {
  if (!!req.typeDef && !!req.typeDef.__singleDataValue__) {
    req.typeDef = undefined;
  }

  return req;
};

var automaticAddSingleValue = function automaticAddSingleValue(req) {
  if (_.isString(req.typeDef)) {
    req.typeDef = {
      __singleDataValue__: {
        type: req.typeDef
      }
    };
  }

  return req;
};

Interface.type('definition', {
  defaultValue: function () {
    return {};
  },
  convertToSource: function convertBackToArray(syncProp, req) {
    return this[this.activeMethod].call(this, automaticRemoveSingleValue(req).typeDef, syncProp);
  },
  convertToSync: function (sourceProp, req, source, sync, isRequired) {
    return isRequired && !_.isUndefined(sourceProp)
      ? this[this.activeMethod].call(this, automaticAddSingleValue(req).typeDef, sourceProp, {})
      : sourceProp;
  },
  isOfType: function (val, req) {
    return this.discoverType(val) === 'object';
  }
})
  .type('dynamic-definition', {
    convertToSource: function convertToSource(syncProp, req, source, sync) {
      return this[this.activeMethod].call(this, findDTD(req, source), syncProp);
    },
    convertToSync: function (sourceProp, req, source, sync, isRequired) {
      return this[this.activeMethod].call(this, findDTD(req, sync), sourceProp, {});
    },
    isOfType: function () {
      // NOTE it is always true, because we are using Interface so it will fail if not in the coversion
      return true;
    }
  })
  .type('array', {
    defaultValue: function () {
      return [];
    },
    convertToSource: function convertBackToArray(syncProp, req) {
      automaticRemoveSingleValue(req);
      return _.map(
        syncProp,
        function (obj) {
          return this[this.activeMethod].call(this, req.typeDef, obj);
        },
        this
      );
    },
    convertToSync: function (sourceProp, req, source, sync, isRequired) {
      if (!isRequired && _.isUndefined(sourceProp)) {
        return sourceProp;
      }

      // note unfortunately we need to capture this here because map will create an array
      if (this.discoverType(sourceProp) !== 'array') {
        return {};
      }

      automaticAddSingleValue(req);
      sourceProp = _.map(
        sourceProp,
        function (obj) {
          return this[this.activeMethod].call(this, req.typeDef, obj, {});
        },
        this
      );

      return sourceProp;
    },
    isOfType: function (val) {
      return this.discoverType(val) === 'array';
    }
  })
  .type('object', {
    defaultValue: function () {
      return {};
    },
    convertToSource: function convertBackToArray(syncProp, req) {
      automaticRemoveSingleValue(req);
      return _.zipObject(
        _.keys(syncProp),
        _.map(
          syncProp,
          function (obj) {
            return this[this.activeMethod].call(this, req.typeDef, obj);
          },
          this
        )
      );
    },
    convertToSync: function (sourceProp, req, source, sync, isRequired) {
      if (!isRequired && _.isUndefined(sourceProp)) {
        return sourceProp;
      }

      automaticAddSingleValue(req);
      _.each(
        sourceProp,
        function (obj, k) {
          sourceProp[k] = this[this.activeMethod].call(this, req.typeDef, obj, {});
        },
        this
      );

      return sourceProp;
    },
    isOfType: function (val, req) {
      return this.discoverType(val) === 'object';
    }
  });



// WEBPACK FOOTER //
// ./app/vendor/utility-js-interface/src/types/collections.js